"use client";
import { c as E, g as lr } from "./_commonjsHelpers-DaMA6jEr.js";
import { useState as Hr } from "react";
import Er from "./hooks/useInterval.js";
var hr = { exports: {} };
(function(r, t) {
  (function(s, c) {
    r.exports = c();
  })(E, function() {
    var s = 1e3, c = 6e4, l = 36e5, y = "millisecond", M = "second", T = "minute", R = "hour", _ = "day", z = "week", p = "month", Q = "quarter", O = "year", x = "date", K = "Invalid Date", Ir = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, kr = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, Cr = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(o) {
      var i = ["th", "st", "nd", "rd"], e = o % 100;
      return "[" + o + (i[(e - 20) % 10] || i[e] || i[0]) + "]";
    } }, W = function(o, i, e) {
      var a = String(o);
      return !a || a.length >= i ? o : "" + Array(i + 1 - a.length).join(e) + o;
    }, Nr = { s: W, z: function(o) {
      var i = -o.utcOffset(), e = Math.abs(i), a = Math.floor(e / 60), n = e % 60;
      return (i <= 0 ? "+" : "-") + W(a, 2, "0") + ":" + W(n, 2, "0");
    }, m: function o(i, e) {
      if (i.date() < e.date()) return -o(e, i);
      var a = 12 * (e.year() - i.year()) + (e.month() - i.month()), n = i.clone().add(a, p), u = e - n < 0, f = i.clone().add(a + (u ? -1 : 1), p);
      return +(-(a + (e - n) / (u ? n - f : f - n)) || 0);
    }, a: function(o) {
      return o < 0 ? Math.ceil(o) || 0 : Math.floor(o);
    }, p: function(o) {
      return { M: p, y: O, w: z, d: _, D: x, h: R, m: T, s: M, ms: y, Q }[o] || String(o || "").toLowerCase().replace(/s$/, "");
    }, u: function(o) {
      return o === void 0;
    } }, k = "en", w = {};
    w[k] = Cr;
    var rr = "$isDayjsObject", G = function(o) {
      return o instanceof L || !(!o || !o[rr]);
    }, F = function o(i, e, a) {
      var n;
      if (!i) return k;
      if (typeof i == "string") {
        var u = i.toLowerCase();
        w[u] && (n = u), e && (w[u] = e, n = u);
        var f = i.split("-");
        if (!n && f.length > 1) return o(f[0]);
      } else {
        var $ = i.name;
        w[$] = i, n = $;
      }
      return !a && n && (k = n), n || !a && k;
    }, m = function(o, i) {
      if (G(o)) return o.clone();
      var e = typeof i == "object" ? i : {};
      return e.date = o, e.args = arguments, new L(e);
    }, d = Nr;
    d.l = F, d.i = G, d.w = function(o, i) {
      return m(o, { locale: i.$L, utc: i.$u, x: i.$x, $offset: i.$offset });
    };
    var L = function() {
      function o(e) {
        this.$L = F(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[rr] = !0;
      }
      var i = o.prototype;
      return i.parse = function(e) {
        this.$d = function(a) {
          var n = a.date, u = a.utc;
          if (n === null) return /* @__PURE__ */ new Date(NaN);
          if (d.u(n)) return /* @__PURE__ */ new Date();
          if (n instanceof Date) return new Date(n);
          if (typeof n == "string" && !/Z$/i.test(n)) {
            var f = n.match(Ir);
            if (f) {
              var $ = f[2] - 1 || 0, h = (f[7] || "0").substring(0, 3);
              return u ? new Date(Date.UTC(f[1], $, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, h)) : new Date(f[1], $, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, h);
            }
          }
          return new Date(n);
        }(e), this.init();
      }, i.init = function() {
        var e = this.$d;
        this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
      }, i.$utils = function() {
        return d;
      }, i.isValid = function() {
        return this.$d.toString() !== K;
      }, i.isSame = function(e, a) {
        var n = m(e);
        return this.startOf(a) <= n && n <= this.endOf(a);
      }, i.isAfter = function(e, a) {
        return m(e) < this.startOf(a);
      }, i.isBefore = function(e, a) {
        return this.endOf(a) < m(e);
      }, i.$g = function(e, a, n) {
        return d.u(e) ? this[a] : this.set(n, e);
      }, i.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, i.valueOf = function() {
        return this.$d.getTime();
      }, i.startOf = function(e, a) {
        var n = this, u = !!d.u(a) || a, f = d.p(e), $ = function(A, g) {
          var j = d.w(n.$u ? Date.UTC(n.$y, g, A) : new Date(n.$y, g, A), n);
          return u ? j : j.endOf(_);
        }, h = function(A, g) {
          return d.w(n.toDate()[A].apply(n.toDate("s"), (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(g)), n);
        }, b = this.$W, v = this.$M, S = this.$D, I = "set" + (this.$u ? "UTC" : "");
        switch (f) {
          case O:
            return u ? $(1, 0) : $(31, 11);
          case p:
            return u ? $(1, v) : $(0, v + 1);
          case z:
            var D = this.$locale().weekStart || 0, C = (b < D ? b + 7 : b) - D;
            return $(u ? S - C : S + (6 - C), v);
          case _:
          case x:
            return h(I + "Hours", 0);
          case R:
            return h(I + "Minutes", 1);
          case T:
            return h(I + "Seconds", 2);
          case M:
            return h(I + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, i.endOf = function(e) {
        return this.startOf(e, !1);
      }, i.$set = function(e, a) {
        var n, u = d.p(e), f = "set" + (this.$u ? "UTC" : ""), $ = (n = {}, n[_] = f + "Date", n[x] = f + "Date", n[p] = f + "Month", n[O] = f + "FullYear", n[R] = f + "Hours", n[T] = f + "Minutes", n[M] = f + "Seconds", n[y] = f + "Milliseconds", n)[u], h = u === _ ? this.$D + (a - this.$W) : a;
        if (u === p || u === O) {
          var b = this.clone().set(x, 1);
          b.$d[$](h), b.init(), this.$d = b.set(x, Math.min(this.$D, b.daysInMonth())).$d;
        } else $ && this.$d[$](h);
        return this.init(), this;
      }, i.set = function(e, a) {
        return this.clone().$set(e, a);
      }, i.get = function(e) {
        return this[d.p(e)]();
      }, i.add = function(e, a) {
        var n, u = this;
        e = Number(e);
        var f = d.p(a), $ = function(v) {
          var S = m(u);
          return d.w(S.date(S.date() + Math.round(v * e)), u);
        };
        if (f === p) return this.set(p, this.$M + e);
        if (f === O) return this.set(O, this.$y + e);
        if (f === _) return $(1);
        if (f === z) return $(7);
        var h = (n = {}, n[T] = c, n[R] = l, n[M] = s, n)[f] || 1, b = this.$d.getTime() + e * h;
        return d.w(b, this);
      }, i.subtract = function(e, a) {
        return this.add(-1 * e, a);
      }, i.format = function(e) {
        var a = this, n = this.$locale();
        if (!this.isValid()) return n.invalidDate || K;
        var u = e || "YYYY-MM-DDTHH:mm:ssZ", f = d.z(this), $ = this.$H, h = this.$m, b = this.$M, v = n.weekdays, S = n.months, I = n.meridiem, D = function(g, j, N, P) {
          return g && (g[j] || g(a, u)) || N[j].slice(0, P);
        }, C = function(g) {
          return d.s($ % 12 || 12, g, "0");
        }, A = I || function(g, j, N) {
          var P = g < 12 ? "AM" : "PM";
          return N ? P.toLowerCase() : P;
        };
        return u.replace(kr, function(g, j) {
          return j || function(N) {
            switch (N) {
              case "YY":
                return String(a.$y).slice(-2);
              case "YYYY":
                return d.s(a.$y, 4, "0");
              case "M":
                return b + 1;
              case "MM":
                return d.s(b + 1, 2, "0");
              case "MMM":
                return D(n.monthsShort, b, S, 3);
              case "MMMM":
                return D(S, b);
              case "D":
                return a.$D;
              case "DD":
                return d.s(a.$D, 2, "0");
              case "d":
                return String(a.$W);
              case "dd":
                return D(n.weekdaysMin, a.$W, v, 2);
              case "ddd":
                return D(n.weekdaysShort, a.$W, v, 3);
              case "dddd":
                return v[a.$W];
              case "H":
                return String($);
              case "HH":
                return d.s($, 2, "0");
              case "h":
                return C(1);
              case "hh":
                return C(2);
              case "a":
                return A($, h, !0);
              case "A":
                return A($, h, !1);
              case "m":
                return String(h);
              case "mm":
                return d.s(h, 2, "0");
              case "s":
                return String(a.$s);
              case "ss":
                return d.s(a.$s, 2, "0");
              case "SSS":
                return d.s(a.$ms, 3, "0");
              case "Z":
                return f;
            }
            return null;
          }(g) || f.replace(":", "");
        });
      }, i.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, i.diff = function(e, a, n) {
        var u, f = this, $ = d.p(a), h = m(e), b = (h.utcOffset() - this.utcOffset()) * c, v = this - h, S = function() {
          return d.m(f, h);
        };
        switch ($) {
          case O:
            u = S() / 12;
            break;
          case p:
            u = S();
            break;
          case Q:
            u = S() / 3;
            break;
          case z:
            u = (v - b) / 6048e5;
            break;
          case _:
            u = (v - b) / 864e5;
            break;
          case R:
            u = v / l;
            break;
          case T:
            u = v / c;
            break;
          case M:
            u = v / s;
            break;
          default:
            u = v;
        }
        return n ? u : d.a(u);
      }, i.daysInMonth = function() {
        return this.endOf(p).$D;
      }, i.$locale = function() {
        return w[this.$L];
      }, i.locale = function(e, a) {
        if (!e) return this.$L;
        var n = this.clone(), u = F(e, a, !0);
        return u && (n.$L = u), n;
      }, i.clone = function() {
        return d.w(this.$d, this);
      }, i.toDate = function() {
        return new Date(this.valueOf());
      }, i.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, i.toISOString = function() {
        return this.$d.toISOString();
      }, i.toString = function() {
        return this.$d.toUTCString();
      }, o;
    }(), tr = L.prototype;
    return m.prototype = tr, [["$ms", y], ["$s", M], ["$m", T], ["$H", R], ["$W", _], ["$M", p], ["$y", O], ["$D", x]].forEach(function(o) {
      tr[o[1]] = function(i) {
        return this.$g(i, o[0], o[1]);
      };
    }), m.extend = function(o, i) {
      return o.$i || (o(i, L, m), o.$i = !0), m;
    }, m.locale = F, m.isDayjs = G, m.unix = function(o) {
      return m(1e3 * o);
    }, m.en = w[k], m.Ls = w, m.p = {}, m;
  });
})(hr);
var zr = hr.exports;
const Y = /* @__PURE__ */ lr(zr);
var Fr = 9007199254740991, Lr = Math.floor;
function Pr(r, t) {
  var s = "";
  if (!r || t < 1 || t > Fr)
    return s;
  do
    t % 2 && (s += r), t = Lr(t / 2), t && (r += r);
  while (t);
  return s;
}
var Yr = Pr, Ur = typeof E == "object" && E && E.Object === Object && E, Wr = Ur, Gr = Wr, Jr = typeof self == "object" && self && self.Object === Object && self, Vr = Gr || Jr || Function("return this")(), Zr = Vr, Br = Zr, qr = Br.Symbol, q = qr;
function Xr(r, t) {
  for (var s = -1, c = r == null ? 0 : r.length, l = Array(c); ++s < c; )
    l[s] = t(r[s], s, r);
  return l;
}
var Qr = Xr, Kr = Array.isArray, rt = Kr, er = q, mr = Object.prototype, tt = mr.hasOwnProperty, et = mr.toString, H = er ? er.toStringTag : void 0;
function nt(r) {
  var t = tt.call(r, H), s = r[H];
  try {
    r[H] = void 0;
    var c = !0;
  } catch {
  }
  var l = et.call(r);
  return c && (t ? r[H] = s : delete r[H]), l;
}
var it = nt, at = Object.prototype, st = at.toString;
function ot(r) {
  return st.call(r);
}
var ut = ot, nr = q, ft = it, ct = ut, dt = "[object Null]", $t = "[object Undefined]", ir = nr ? nr.toStringTag : void 0;
function lt(r) {
  return r == null ? r === void 0 ? $t : dt : ir && ir in Object(r) ? ft(r) : ct(r);
}
var ht = lt;
function mt(r) {
  return r != null && typeof r == "object";
}
var bt = mt, vt = ht, gt = bt, yt = "[object Symbol]";
function St(r) {
  return typeof r == "symbol" || gt(r) && vt(r) == yt;
}
var br = St, ar = q, pt = Qr, Mt = rt, Tt = br, _t = 1 / 0, sr = ar ? ar.prototype : void 0, or = sr ? sr.toString : void 0;
function vr(r) {
  if (typeof r == "string")
    return r;
  if (Mt(r))
    return pt(r, vr) + "";
  if (Tt(r))
    return or ? or.call(r) : "";
  var t = r + "";
  return t == "0" && 1 / r == -_t ? "-0" : t;
}
var gr = vr;
function Ot(r, t, s) {
  var c = -1, l = r.length;
  t < 0 && (t = -t > l ? 0 : l + t), s = s > l ? l : s, s < 0 && (s += l), l = t > s ? 0 : s - t >>> 0, t >>>= 0;
  for (var y = Array(l); ++c < l; )
    y[c] = r[c + t];
  return y;
}
var jt = Ot, wt = jt;
function Dt(r, t, s) {
  var c = r.length;
  return s = s === void 0 ? c : s, !t && s >= c ? r : wt(r, t, s);
}
var At = Dt, Rt = "\\ud800-\\udfff", xt = "\\u0300-\\u036f", It = "\\ufe20-\\ufe2f", kt = "\\u20d0-\\u20ff", Ct = xt + It + kt, Nt = "\\ufe0e\\ufe0f", Ht = "\\u200d", Et = RegExp("[" + Ht + Rt + Ct + Nt + "]");
function zt(r) {
  return Et.test(r);
}
var X = zt;
function Ft(r) {
  return function(t) {
    return t == null ? void 0 : t[r];
  };
}
var Lt = Ft, Pt = Lt, Yt = Pt("length"), Ut = Yt, yr = "\\ud800-\\udfff", Wt = "\\u0300-\\u036f", Gt = "\\ufe20-\\ufe2f", Jt = "\\u20d0-\\u20ff", Vt = Wt + Gt + Jt, Zt = "\\ufe0e\\ufe0f", Bt = "[" + yr + "]", J = "[" + Vt + "]", V = "\\ud83c[\\udffb-\\udfff]", qt = "(?:" + J + "|" + V + ")", Sr = "[^" + yr + "]", pr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Mr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xt = "\\u200d", Tr = qt + "?", _r = "[" + Zt + "]?", Qt = "(?:" + Xt + "(?:" + [Sr, pr, Mr].join("|") + ")" + _r + Tr + ")*", Kt = _r + Tr + Qt, re = "(?:" + [Sr + J + "?", J, pr, Mr, Bt].join("|") + ")", ur = RegExp(V + "(?=" + V + ")|" + re + Kt, "g");
function te(r) {
  for (var t = ur.lastIndex = 0; ur.test(r); )
    ++t;
  return t;
}
var ee = te, ne = Ut, ie = X, ae = ee;
function se(r) {
  return ie(r) ? ae(r) : ne(r);
}
var Or = se;
function oe(r) {
  return r.split("");
}
var ue = oe, jr = "\\ud800-\\udfff", fe = "\\u0300-\\u036f", ce = "\\ufe20-\\ufe2f", de = "\\u20d0-\\u20ff", $e = fe + ce + de, le = "\\ufe0e\\ufe0f", he = "[" + jr + "]", Z = "[" + $e + "]", B = "\\ud83c[\\udffb-\\udfff]", me = "(?:" + Z + "|" + B + ")", wr = "[^" + jr + "]", Dr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ar = "[\\ud800-\\udbff][\\udc00-\\udfff]", be = "\\u200d", Rr = me + "?", xr = "[" + le + "]?", ve = "(?:" + be + "(?:" + [wr, Dr, Ar].join("|") + ")" + xr + Rr + ")*", ge = xr + Rr + ve, ye = "(?:" + [wr + Z + "?", Z, Dr, Ar, he].join("|") + ")", Se = RegExp(B + "(?=" + B + ")|" + ye + ge, "g");
function pe(r) {
  return r.match(Se) || [];
}
var Me = pe, Te = ue, _e = X, Oe = Me;
function je(r) {
  return _e(r) ? Oe(r) : Te(r);
}
var we = je, fr = Yr, De = gr, Ae = At, Re = X, xe = Or, Ie = we, ke = Math.ceil;
function Ce(r, t) {
  t = t === void 0 ? " " : De(t);
  var s = t.length;
  if (s < 2)
    return s ? fr(t, r) : t;
  var c = fr(t, ke(r / xe(t)));
  return Re(t) ? Ae(Ie(c), 0, r).join("") : c.slice(0, r);
}
var Ne = Ce, He = /\s/;
function Ee(r) {
  for (var t = r.length; t-- && He.test(r.charAt(t)); )
    ;
  return t;
}
var ze = Ee, Fe = ze, Le = /^\s+/;
function Pe(r) {
  return r && r.slice(0, Fe(r) + 1).replace(Le, "");
}
var Ye = Pe;
function Ue(r) {
  var t = typeof r;
  return r != null && (t == "object" || t == "function");
}
var We = Ue, Ge = Ye, cr = We, Je = br, dr = NaN, Ve = /^[-+]0x[0-9a-f]+$/i, Ze = /^0b[01]+$/i, Be = /^0o[0-7]+$/i, qe = parseInt;
function Xe(r) {
  if (typeof r == "number")
    return r;
  if (Je(r))
    return dr;
  if (cr(r)) {
    var t = typeof r.valueOf == "function" ? r.valueOf() : r;
    r = cr(t) ? t + "" : t;
  }
  if (typeof r != "string")
    return r === 0 ? r : +r;
  r = Ge(r);
  var s = Ze.test(r);
  return s || Be.test(r) ? qe(r.slice(2), s ? 2 : 8) : Ve.test(r) ? dr : +r;
}
var Qe = Xe, Ke = Qe, $r = 1 / 0, rn = 17976931348623157e292;
function tn(r) {
  if (!r)
    return r === 0 ? r : 0;
  if (r = Ke(r), r === $r || r === -$r) {
    var t = r < 0 ? -1 : 1;
    return t * rn;
  }
  return r === r ? r : 0;
}
var en = tn, nn = en;
function an(r) {
  var t = nn(r), s = t % 1;
  return t === t ? s ? t - s : t : 0;
}
var sn = an, on = gr;
function un(r) {
  return r == null ? "" : on(r);
}
var fn = un, cn = Ne, dn = Or, $n = sn, ln = fn;
function hn(r, t, s) {
  r = ln(r), t = $n(t);
  var c = t ? dn(r) : 0;
  return t && c < t ? cn(t - c, s) + r : r;
}
var mn = hn;
const bn = /* @__PURE__ */ lr(mn), vn = 1e3, U = (r) => bn(String(r), 2, "0"), gn = (r, t) => {
  const s = r.diff(t, "day"), c = r.diff(t, "hours") % 24, l = r.diff(t, "minutes") % 60, y = r.diff(t, "seconds") % 60;
  return {
    days: s,
    hours: c,
    minutes: l,
    seconds: y,
    formattedDays: U(s),
    formattedHours: U(c),
    formattedMinutes: U(l),
    formattedSeconds: U(y)
  };
}, Mn = (r, t) => {
  const s = !!t, c = s ? Y() : Y(r), l = s ? Y(r) : Y(), y = c.unix() < l.unix(), [M, T] = Hr();
  return Er(
    () => T(gn(c, l)),
    y ? null : vn
  ), y ? null : M;
};
export {
  Y as d,
  Mn as u
};
